import { render } from "./MinBarChart.vue?vue&type=template&id=31f21f5f&scoped=true"
import script from "./MinBarChart.vue?vue&type=script&lang=js"
export * from "./MinBarChart.vue?vue&type=script&lang=js"

import "./MinBarChart.vue?vue&type=style&index=0&id=31f21f5f&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f21f5f"]])

export default __exports__